export class SnackbarData {
  icon?: string;
  message: string;
  dismissHandler: () => void;
}
